import { render, staticRenderFns } from "./PostTable.vue?vue&type=template&id=c1a69930"
import script from "./PostTable.vue?vue&type=script&lang=js"
export * from "./PostTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports